import * as Styles from "layouts/PrivateLayout.styles"
import { Typography } from "@mui/material" 
import { IOrder } from "services/orders"
import { formatCurrency } from "utils/intlNumber"
interface IPaymentsData {
    order?: IOrder | any
}
const OrderPayments: React.FC<IPaymentsData> = ({
    order
}) => {
    const totalPrice = formatCurrency(order?.total_price ?? 0)
    return <>
        <Styles.FlexContainer flex-col>
            <Styles.FlexContainer className="flex border-t border-b border-gray-200 pt-2">
                <Styles.FlexContainerColumn>
                    <Styles.FlexContainer>
                        <Styles.FlexContainerColumn className="pr-16">
                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                Subtotal
                            </Typography>
                        </Styles.FlexContainerColumn>
                        <Styles.FlexContainerColumn>
                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                {order?.order_line_items.length ?? 0} Item(s)
                            </Typography>
                        </Styles.FlexContainerColumn>
                    </Styles.FlexContainer>
                    <Styles.FlexContainer>
                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                            Total
                        </Typography>
                    </Styles.FlexContainer>                    
                </Styles.FlexContainerColumn>
                <Styles.FlexContainerColumn push-right>
                    <Styles.FlexContainerColumn>
                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                            { totalPrice }
                        </Typography>
        
                    </Styles.FlexContainerColumn>
                    <Styles.FlexContainerColumn>
                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                            { totalPrice }
                        </Typography>
                    </Styles.FlexContainerColumn>
                </Styles.FlexContainerColumn>
            </Styles.FlexContainer>
            <Styles.FlexContainer className="pt-2">
                <Styles.FlexContainerColumn>
                    <Styles.FlexContainerColumn>
                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                            Paid
                        </Typography>
                    </Styles.FlexContainerColumn>                    
                </Styles.FlexContainerColumn>
                <Styles.FlexContainerColumn push-right>
                    <Styles.FlexContainerColumn>
                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                            { totalPrice }
                        </Typography>
                    </Styles.FlexContainerColumn>
                </Styles.FlexContainerColumn>
            </Styles.FlexContainer>
        </Styles.FlexContainer>
    </>
}

export default OrderPayments